import React from 'react';
import { connect } from 'react-redux';
import ContentWrapper from '../lib_react_adminlte/componentes/ContentWrapper.jsx';
import Box from '../lib_react_adminlte/componentes/Box.jsx';
import Api from '../utils/Api.jsx';
import { getNomeMes } from '../utils/utils';

class Empresa extends React.Component {

  state = {
    empresa: {},
    backups: [],
  }

  async componentWillMount() {
    await this.carregar();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.socket.backup !== nextProps.socket.backup) {
      this.carregar();
    }
  }
  
  async carregar() {
    const pathsUrl = window.location.href.split('/');
    const cnpj = pathsUrl[pathsUrl.length - 1];
    const ret = await Api.getEmpresaBackups(cnpj);
    if (!ret.status) {
      // console.log(ret);
      return;
    }
    this.setState({ empresa: ret.dados.empresa, backups: ret.dados.backups });
  }
  
  renderMeses(dados) {
    return dados.map(x => (
      <div className="campoDownload m-0">
        <span className='fs-20 wx-100 fl block my-5'>
          {getNomeMes(x.mes)}
        </span>
        <div>
          {x.arquivos.map(y => (
            <div>
              <a target='blank' href={y.link_download}>
                {y.nome_arquivo}
              </a>
              <span style={{float:'right'}}> {y.hora_recebimento}</span>
            </div>   
          ))}
        </div>
      </div>
    ));
  }

  render() {  
    return (
      <ContentWrapper title={this.state.empresa.nome_fantasia}
                      small={this.state.empresa.razao_social}>
        {this.state.backups.map(x => (
          <Box collapsible title={x.ano} className="m-0">
            {this.renderMeses(x.meses)}
          </Box>
        ))}
      </ContentWrapper>
    );
  }
}

export default connect((state) => ({
  socket: state.socket,
}))(Empresa);



// WEBPACK FOOTER //
// ./src/componentes/Empresa.jsx